import React from "react";

// Reference board order (market id `i` in casinoData.sub per cell)
const RIGHT = [138, 137, 136]; // 3rd / 2nd / 1st Column — all read "2to1"
const BOTTOM = [
  [133, "1st12"],
  [134, "2nd12"],
  [135, "3rd12"],
  [139, "1 - 18"],
  [144, "Even"],
  [141, "Red"],
  [142, "Black"],
  [143, "Odd"],
  [140, "19 - 36"],
];
const RED = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
const numberColor = (n) => (n === 0 ? "green" : RED.includes(n) ? "red" : "black");

/**
 * Roulette bet board in the reference markup (.roulette-box-container > .board-in >
 * .board-right / .board-bottom / .board-center), styled by the ported rules in index.css.
 * A cell is `.suspended` unless its market (sub item with that `i`) has s == 1, like the reference.
 */
export default function RouletteBoard({ sub = [], lt, onBetClick }) {
  const byId = {};
  sub.forEach((m) => {
    if (m && m.i != null) byId[m.i] = m;
  });
  const cell = (id, color, content) => {
    const market = byId[id];
    // Result phase (lt 0): every cell locks, the winning number too (reference admin).
    const suspended = !(Number(lt) > 0) || String(market?.s) !== "1";
    return (
      <div
        key={id}
        className={`board-cell ${color}${suspended ? " suspended" : ""}`}
        onClick={suspended || !onBetClick ? undefined : () => onBetClick(market)}
      >
        <div className="board-cell-in">{content}</div>
      </div>
    );
  };
  const join = (nodes) => nodes.flatMap((n, idx) => (idx ? [" ", n] : [n]));

  return (
    <div className="roulette-box-container">
      <div className="board-in">
        <div className="board-right">
          {join(
            RIGHT.map((id, idx) =>
              cell(
                id,
                "yellow",
                idx === 0 ? (
                  <span id="138" className="board-text center-center">
                    2to1
                  </span>
                ) : (
                  <span className="board-text">2to1</span>
                ),
              ),
            ),
          )}
        </div>{" "}
        <div className="board-bottom">
          {join(BOTTOM.map(([id, label]) => cell(id, "yellow", <span className="board-text">{label}</span>)))}
        </div>{" "}
        <div className="board-center">
          {join(
            Array.from({ length: 37 }, (_, n) =>
              cell(n + 1, numberColor(n), <span className="board-number">{n}</span>),
            ),
          )}
        </div>
      </div>
    </div>
  );
}
